import { useAtom } from '@reatom/npm-react'
import { memo } from 'react'
import styled from 'styled-components'

import { Numeric } from '@blade/ui-kit'
import { Trend } from '@root/entities/trend'
import { TrendTriangle } from '@root/entities/trend/ui'
import { FlashTextContentDistinct } from '@root/features/flash/flash-text-content-distinct'

import type { PairMetrics, PairModel } from '@root/entities/pair'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  pair: PairModel
  priceChangePeriod: PairMetrics.MetricsSpan
} & ClassNameProps

export const TradingPairExploreItemMetricsPercent: React.FC<Props> = memo(
  ({ pair, className, priceChangePeriod }) => {
    const [priceChange] = useAtom(pair.stats[priceChangePeriod].priceChange)

    if (priceChange.isZero() || !priceChange.isFinite()) {
      return <span />
    }

    const trend = Trend.of(priceChange)

    return (
      <Percent $dir={trend} className={className}>
        <TrendTriangle trend={trend} size={12} />
        <FlashTextContentDistinct>
          <Numeric
            value={Math.abs(priceChange.toNumber())}
            preset="trend-change-percents"
          />
          %
        </FlashTextContentDistinct>
      </Percent>
    )
  },
)

const Percent = styled.span<{ $dir: Trend.Trend }>`
  color: ${({ $dir }) =>
    $dir === Trend.Down ? 'var(--down-9)' : 'var(--up-9)'};

  display: grid;
  grid-template-columns: auto auto;
  align-items: center;

  font-size: 12px;
  font-weight: 500;
  line-height: normal;
`
